import { getApiUrl } from '@/api/apiClient';

const BASE = '/api/transfer_recipients';

export default {
  create: () => getApiUrl(BASE),
  update: (id) => getApiUrl(`${BASE}/${id}`),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  getAllByAgency: (id) => getApiUrl(`/api/agencies/${id}/transfer_recipients`),
  getProviderEntityById: (id) => getApiUrl(`${BASE}/${id}/provider_entity`),
  saveIdentifiers: (id) => getApiUrl(`${BASE}/${id}/agency_identifiers`),
  getIdentifiers: (id) => getApiUrl(`${BASE}/${id}/agency_identifiers`),
};
